import React from 'react';
import {
  FaArrowRight,
  FaBuilding,
  FaClipboardList,
  FaHardHat,
  FaPhoneAlt,
} from 'react-icons/fa';
import { HiOutlineLightBulb } from 'react-icons/hi2';

import {
  Section,
  Container,
  Content,
  Eyebrow,
  Title,
  Description,
  FeatureList,
  FeatureItem,
  FeatureIcon,
  FeatureContent,
  FeatureTitle,
  FeatureText,
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  ButtonIcon,
  GuidanceCard,
  CardLabel,
  CardIcon,
  CardTitle,
  CardDescription,
  CardSteps,
  CardStep,
  StepNumber,
  StepContent,
  StepTitle,
  StepText,
} from './HelpChoosing.styles';

const guidancePoints = [
  {
    icon: <FaBuilding />,
    title: 'Your workplace',
    text: 'Tell us about your industry, work environment, and the tasks your team performs.',
  },
  {
    icon: <FaClipboardList />,
    title: 'Your safety needs',
    text: 'Share the hazard, product category, quantity, or workplace concern you need to address.',
  },
  {
    icon: <FaHardHat />,
    title: 'Available product options',
    text: 'Our team can help identify suitable products and confirm details before you order.',
  },
];

const guidanceSteps = [
  {
    number: '01',
    title: 'Describe what you need',
    text: 'Send us the product name, category, quantity, or workplace requirement.',
  },
  {
    number: '02',
    title: 'Review your options',
    text: 'We will help explore suitable products and provide relevant details.',
  },
  {
    number: '03',
    title: 'Request pricing',
    text: 'Receive product information, availability, and pricing directly from our team.',
  },
];

export default function ProductGuidance() {
  return (
    <Section id="product-guidance">
      <Container>
        <Content>
          <Eyebrow>Product Guidance</Eyebrow>

          <Title>Not Sure Which Product Is Right for Your Workplace?</Title>

          <Description>
            Choosing the right safety products depends on your workplace,
            hazards, and operational needs. Our team can help narrow down the
            best options before you place an order.
          </Description>

          <FeatureList>
            {guidancePoints.map((point) => (
              <FeatureItem key={point.title}>
                <FeatureIcon aria-hidden="true">{point.icon}</FeatureIcon>

                <FeatureContent>
                  <FeatureTitle>{point.title}</FeatureTitle>
                  <FeatureText>{point.text}</FeatureText>
                </FeatureContent>
              </FeatureItem>
            ))}
          </FeatureList>

          <ButtonGroup>
            <PrimaryButton href="/contact-us">
              Get Product Guidance
              <ButtonIcon aria-hidden="true">
                <FaArrowRight />
              </ButtonIcon>
            </PrimaryButton>

            <SecondaryButton href="tel:+19024781972">
              <FaPhoneAlt aria-hidden="true" />
              Call Our Team
            </SecondaryButton>
          </ButtonGroup>
        </Content>

        <GuidanceCard>
          <CardLabel>How We Can Help</CardLabel>

          <CardIcon aria-hidden="true">
            <HiOutlineLightBulb />
          </CardIcon>

          <CardTitle>Simple Guidance. Clear Next Steps.</CardTitle>

          <CardDescription>
            You don&apos;t need to know exactly what you need before contacting
            us. Start with your workplace and we&apos;ll guide you from there.
          </CardDescription>

          <CardSteps>
            {guidanceSteps.map((step) => (
              <CardStep key={step.number}>
                <StepNumber>{step.number}</StepNumber>

                <StepContent>
                  <StepTitle>{step.title}</StepTitle>
                  <StepText>{step.text}</StepText>
                </StepContent>
              </CardStep>
            ))}
          </CardSteps>
        </GuidanceCard>
      </Container>
    </Section>
  );
}
